/**
 * **SKU XCONS = `MARCA-SKU Fabricante`** (Excel de Maxi). Es la misma regla que
 * `xcons-api/src/pim/validation/sku-xcons.ts`, y la que decide es la del API: acá se
 * usa para **mostrar** el SKU mientras se tipea y para partir uno existente. Si las dos
 * se desalinearan, el guardado del alta daría 422 `SKU_MISMATCH` en vez de guardar mal.
 *
 * La marca va en mayúsculas y **sólo los espacios** pasan a `_` (`DOBLE A` →
 * `DOBLE_A-…`); el resto se conserva (`H&D-…`, `WD-40-…`). Así está el 99,98% del catálogo.
 */
export const SKU_FABRICANTE_MAX = 32;

export const prefijoDeMarca = (marca: string) =>
  `${marca.trim().toUpperCase().replace(/\s+/g, "_")}-`;

export const componerSkuXcons = (marca: string, skuFabricante: string) =>
  `${prefijoDeMarca(marca)}${skuFabricante.trim()}`;

/** El SKU del fabricante que el SKU lleva adentro, o `null` si no sigue la regla. */
export function skuFabricanteDe(
  sku: string | null | undefined,
  marca: string | null | undefined,
): string | null {
  if (!sku || !marca?.trim()) return null;
  const prefijo = prefijoDeMarca(marca);
  if (!sku.startsWith(prefijo)) return null;
  return sku.slice(prefijo.length) || null;
}
